import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-second',
  imports: [],
  templateUrl: './second.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './second.component.css'
})
export class SecondComponent {

}
